/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "不可販售或分享我的個人資料",
      "Bumble Date",
      "我們的應用程式",
      "關於",
      "工作機會",
      "聯絡我們",
      "投資者",
      "商店",
      "公司",
      "下載應用程式",
      "Bumble 的無障礙政策",
      "指導原則",
      "管理 Cookie",
      "現代奴役法案",
      "資料收集聲明",
      "隱私權政策",
      "條款與細則",
      "法務",
      "華盛頓州消費者健康資料隱私權政策",
      "掃瞄 QR 碼，即可下載 Bumble 應用程式",
      "在此終止合約",
      "選擇選單",
      "打開選單",
      "選擇語言",
      "腳註",
      "Bumble的無障礙功能",
      "Apple 和 Apple 標誌是 Apple Inc. 的商標",
      "Bumble BFF",
      "Bumble Bizz",
      "Bumble Date",
      "工作機會",
      "Google Play是 Google LLC 的商標。",
      "指導原則",
      "投資家",
      "管理 Cookie",
      "現代奴役法案聲明",
      "資料收集聲明",
      "隱私權政策",
      "不同季節的約會指南",
      "條款",
      "應用",
      "Washington Consumer Health Data Privacy Policy",
      "關於",
      "大使",
      "結交新朋友，尋找自己的社群",
      "拓展專業網絡，令事業更進一步",
      "認真戀愛、隨意約會或其他關係",
      "The Buzz",
      "瞭解更多",
      "使用旅行模式全球行動",
      "約會",
      "功能",
      "Compliments™",
      "送出 Compliments 讓自己脫穎而出。",
      "探索",
      "個人化頁面每天更新，與你最合拍的人就在眼前。",
      "隱身模式",
      "使用隱身模式隱藏檔案，不讓同事、親友或前任看見你。",
      "立即配對",
      "在 Bumble 實體活動聊不久？應用程式裡繼續聊！",
      "開場白",
      "使用 <b>Opening Moves</b> 讓對方開啟對話，你也不用想破腦袋。",
      "瞌睡模式",
      "透過瞌睡模式先暫停一下，準備好約會時再回歸。",
      "超級滑動",
      "對方檔案看起來還不錯？透過超級滑動讓對方知道。",
      "旅行模式",
      "透過旅行模式在全球配對。",
      "視訊聊天",
      "通過視訊和語音通話，嘗試判斷是否準備好面對面見面。",
      "網頁應用程式",
      "從瀏覽器直接體驗 Bumble 體驗。",
      "下載 Bumble 應用程式",
      "BFF",
      "安全",
      "故事",
      "支援",
      "商店",
      "主要",
      "向對方送出讚美，讓自己脫穎而出。",
      "讚美",
      "功能經過精心設計，旨在創造一個真實、互相尊重和有意義的空間，讓會員互相連結。",
      "隱藏個人檔案，不讓老闆、親戚或前任看見你。",
      "隱身模式",
      "利用「瞌睡模式」暫停交友。",
      "瞌睡模式",
      "看到喜歡的人嗎？讓對方知道你的心意。",
      "超級滑動",
      "探索 Date",
      "出國除了買免稅小吃，還可隨時隨地與人配對。",
      "旅行模式",
      "無需出門，也有如真人見面。",
      "視訊通話",
      "我們的領袖致力將 Bumble 的價值觀，帶進各個社群。",
      "社群領袖",
      "功能經過精心設計，旨在協助你找到適合你的人，交流共同興趣。",
      "籌備群組聚會，或探索附近的地區活動。",
      "聚起來",
      "探索 BFF",
      "助你尋找愛情和友誼的各種指引和靈感。",
      "與你分享各種建議和故事，助你建立理想友誼。",
      "友誼中心",
      "從東京到多倫多，在 Bumble 上成功尋愛的故事遍佈全球。",
      "愛情故事",
      "無論何時、何地、與誰約會，都要計劃完美約會。",
      "不同季節的約會指南",
      "探索故事",
      "閱讀更多",
      "Bumble 的 {{social_network}}",
      "與我們聯絡",
      "登入",
      "(opens in new window)",
      "常見問答",
      "Cookie Policy",
      "Bumble - 博客",
      "工作機會",
      "聊天",
      "城市",
      "管理cookies",
      "版權所有 © 2006 – 至今。Bumble保留所有版權",
      "自信約會報告",
      "Apple和Apple標誌是Apple Inc.的商標。{{__EOL__}}Google Play標誌是Google LLC.的商標",
      "下載",
      "Facebook",
      "追蹤我們",
      "幫助中心",
      "Instagram",
      "語言",
      "LinkedIn",
      "Bumble屬於Bumble Inc",
      "隱私政策",
      "安全中心",
      "網站導覽",
      "現代奴役法案聲明",
      "條款和細則",
      "Twitter"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "天"
            ],
            "singular": [
                  "天"
            ]
      },
      "hour": {
            "plural": [
                  "小時"
            ],
            "singular": [
                  "小時"
            ]
      },
      "minute": {
            "plural": [
                  "分鐘"
            ],
            "singular": [
                  "分鐘"
            ]
      },
      "month": {
            "plural": [
                  "月"
            ],
            "singular": [
                  "月"
            ]
      },
      "second": {
            "plural": [
                  "秒"
            ],
            "singular": [
                  "秒"
            ]
      },
      "year": {
            "plural": [
                  "年"
            ],
            "singular": [
                  "年"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
